import { render, staticRenderFns } from "./AtcTicketCheck.vue?vue&type=template&id=25b0e86a&scoped=true&"
import script from "./AtcTicketCheck.vue?vue&type=script&lang=js&"
export * from "./AtcTicketCheck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25b0e86a",
  null
  
)

export default component.exports